<div class="hero-carousel-error">
  <div class="hero-carousel-error__content">
    <div class="hero-carousel-error__icon" aria-hidden="true">⚠️</div>
    <h2 class="hero-carousel-error__title">Error al cargar contenido</h2>
    <p class="hero-carousel-error__message">
      {{
        error ||
          'No se pudieron cargar las ofertas. Por favor, intenta nuevamente.'
      }}
    </p>
    <button
      type="button"
      class="hero-carousel-error__retry-button"
      (click)="onRetry()"
      aria-label="Reintentar carga de ofertas"
    >
      <span class="hero-carousel-error__retry-icon" aria-hidden="true"
        >🔄</span
      >
      Reintentar
    </button>
  </div>
</div>
